import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, Image, Row, Upload } from 'antd';
import { CheckUserExistingAndAddToReserve_Reserve_User_Api } from '../../API/ReserveUserApi';
import { GetRelationListId_Setting_Api, GetStateListId_Setting_Api } from '../../API/SettingApi';

import { GetPerson_User_Api } from '../../API/userApi';
import {
    CloseOutlined,
    CheckOutlined,
    UploadOutlined
} from '@ant-design/icons';
import { CustomTypeCombo } from '../CustomType/CustomTypeCombo';

// -----------------------------------------------------------
// وارد کردن DatePicker و تنظیمات شمسی
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// -----------------------------------------------------------

// =================================================================
const SERVER_DATE_FORMAT = "YYYY-MM-DD";

/**
 * تابع کمکی برای تبدیل ارقام فارسی/عربی به انگلیسی و تبدیل اسلش به خط تیره.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    let output = String(str).trim();

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    return output.replace(/\//g, "-");
};

// =================================================================
/**
 * آداپتور سفارشی PersianDatePickerAdapter برای استفاده در فیلد تاریخ تولد
 * این تابع به عنوان یک کامپوننت داخلی تعریف شده تا بتواند با Form.Item و onChange به درستی کار کند.
 */
const PersianDatePickerAdapter = ({ value, onChange, placeholder, onDateSelect }) => {
    const handleOnChange = (dateObject) => {
        let dateString = null;
        if (dateObject && !Array.isArray(dateObject)) {
            dateString = persianToEnglishNumbers(dateObject.format(SERVER_DATE_FORMAT));
        }
        onChange(dateString); // برای اتصال به Form.Item
        if (onDateSelect) {
            onDateSelect(dateString); // برای فراخوانی تابع جانبی مثل getPersonInfo
        }
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input"
            calendarPosition="bottom-right"
            format={SERVER_DATE_FORMAT}
            placeholder={placeholder}
        />
    );
};
// =================================================================

export const AddOthersComponent = ({
    setLoading,
    showMessage,
    reserveId,
    period,
    rowInserted,
    cancelInsert,
    onPrimaryAdded
}) => {
    // =================================================================
    const [form] = Form.useForm();
    const [birthDate, setBirthDate] = useState(); // shamsiBirthDate value
    const [file, setFile] = useState(null);
    const [relationId, setRelationId] = useState(-1);
    const [photoUrl, setPhotoUrl] = useState(null);
    const [stateId, setStateId] = useState(null);
    const [cityId, setCityId] = useState(-1);

    const [relationListId, setRelationListId] = useState(-1);
    const [stateListId, setStateListId] = useState(-1);

    // =================================================================
    useEffect(() => {
        loadSetting();
    }, []);
    // =================================================================
    const loadSetting = async () => {
        setLoading(true);
        try {
            const data = await GetRelationListId_Setting_Api();
            if (data.messageStatus === "Successful") {
                setRelationListId(data.messageData.data);
            }
            else {
                showMessage(data.message, "error");
            }

            const data2 = await GetStateListId_Setting_Api();
            if (data2.messageStatus === "Successful") {
                setStateListId(data2.messageData.data);
            }
            else {
                showMessage(data2.message, "error");
            }

        }
        catch (error) {
            showMessage("خطا در ارتباط با سرور.", "error");
        }
        finally {
            setLoading(false);
        }
    }
    // =================================================================
    const onSubmit = async (values) => {
        try {
            values.id = 0;
            values.shamsiBirthDate = birthDate || "";
            values.birthPlaceId = cityId;

            if (period?.getOthersPhoto && period?.forceGetOthersPhoto && !(file || photoUrl)) {
                showMessage('آپلود تصویر چهره اجباری است.', "error");
                return;
            }

            setLoading(true);

            const formData = new FormData();
            formData.append("reserveId", reserveId);
            formData.append("relationId", relationId);

            if (file) {
                formData.append("photo", file);
            }

            //برای person
            Object.entries(values).forEach(([key, value]) => {
                // تبدیل مقدار به رشته و استفاده از "1" در صورت تهی بودن، مطابق با کد اصلی
                formData.append(key, value !== undefined && value !== null ? String(value) : "1");
            });

            let data = await CheckUserExistingAndAddToReserve_Reserve_User_Api(formData);

            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful");
                rowInserted();
                //اگر نفر اصلی اضافه شده بود
                if (data.messageData.data === true && onPrimaryAdded) {
                    onPrimaryAdded();
                }
            }
            else {
                showMessage(data.message, "error");
            }
        }
        catch (error) {
            showMessage(error.message || "خطا در ارسال اطلاعات", "error");
        }
        finally {
            setLoading(false);
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage('لطفا فیلدهای اجباری را تکمیل نمایید.', "error");
    };
    // =================================================================
    const getPersonInfo = async (dateString) => {
        const nationalCode = form.getFieldValue('nationalCode');
        const shamsiBirthDate = dateString || birthDate || "";

        if (!nationalCode || nationalCode.length < 5) {
            return;
        }

        const params = {
            "NationalCode": nationalCode,
            "ShamsiBirthDate": shamsiBirthDate
        };

        try {
            setLoading(true);
            let data = await GetPerson_User_Api(params);
            
            if (data.messageStatus === "Successful") {
                if (data.messageData.data != null) {
                    form.setFieldsValue({
                        name: data.messageData.data.name,
                        family: data.messageData.data.family,
                        fatherName: data.messageData.data.fatherName
                    });
                    setPhotoUrl(data.messageData.data.photoUrl);
                } else {
                    // در صورت عدم یافتن، فیلدهای نام را خالی می کنیم تا کاربر وارد کند.
                    form.setFieldsValue({
                        name: undefined,
                        family: undefined,
                        fatherName: undefined
                    });
                    setPhotoUrl(null);
                }
            }
        }
        catch (error) {
            // نمایش خطا را غیرفعال می‌کنیم طبق کامنت کد اصلی
            // showMessage("خطا در ارتباط با سرور", "error")
        }
        finally {
            setLoading(false);
        }
    }
    // =================================================================
    const handleFileChange = (info) => {
        // انتخاب اولین فایل
        if (info.fileList.length > 0) {
            setFile(info.fileList[0].originFileObj);
        } else {
            setFile(null);
        }
    };
    // =================================================================
    return (
        <>
            <div className='container'>
                <Form
                    name="basic"
                    form={form}
                    onFinish={onSubmit}
                    onFinishFailed={onFinishFailed}
                >
                    <Row gutter={[16, 16]}>
                        <Col xs={0} sm={0} md={0} lg={1} xl={1} >
                            <div className='add-others-title' style={{ color: 'white' }}>تصویر </div>
                            {photoUrl && (
                                <Image
                                    width={30}
                                    height={40}
                                    src={photoUrl} />
                            )}
                        </Col>

                        <Col xs={12} sm={12} md={8} lg={5} xl={5} >
                            <div className='add-others-title'>کد ملی:</div>
                            <Form.Item
                                name="nationalCode"
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <Input 
                                    style={{ width: '90%' }} 
                                    placeholder='کد ملی' 
                                    onChange={() => getPersonInfo("")} 
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={12} sm={12} md={8} lg={5} xl={5} >
                            <div className='add-others-title'>تاریخ تولد:</div>
                            <Form.Item
                                name="shamsiBirthDate"
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <PersianDatePickerAdapter 
                                    onChange={setBirthDate} 
                                    onDateSelect={getPersonInfo}
                                    placeholder="تاریخ تولد" 
                                />
                            </Form.Item>
                        </Col>
                        
                        <Col xs={12} sm={12} md={8} lg={3} xl={5} >
                            <div className='add-others-title'>نام:</div>
                            <Form.Item
                                name="name"
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <Input style={{ width: '90%' }} placeholder='نام' />
                            </Form.Item>
                        </Col>

                        <Col xs={12} sm={12} md={8} lg={3} xl={5} >
                            <div className='add-others-title'>نام خانوادگی:</div>
                            <Form.Item
                                name="family"
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <Input style={{ width: '90%' }} placeholder='نام خانوادگی' />
                            </Form.Item>
                        </Col>

                        <Col xs={12} sm={12} md={8} lg={3} xl={3} >
                            <div className='add-others-title'>نام پدر:</div>
                            <Form.Item
                                name="fatherName"
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <Input style={{ width: '90%' }} placeholder='نام پدر' />
                            </Form.Item>
                        </Col>
                        
                        <Col xs={0} sm={0} md={0} lg={1} xl={1} />
                        
                        <Col xs={12} sm={12} md={8} lg={3} xl={5}>
                            <div className='add-others-title'>نسبت:</div>
                            <Form.Item
                                name="relation"
                                // افزودن قانون اجباری بودن در صورت نیاز
                                // rules={[{ required: true, message: 'انتخاب نسبت اجباری است!' }]}
                            >
                                <CustomTypeCombo
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    placeHolder="نسبت"
                                    parentId={relationListId}
                                    onChange={(value) => { setRelationId(value) }}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={12} sm={12} md={8} lg={3} xl={5}>
                            <div className='add-others-title'>استان تولد:</div>
                            <Form.Item
                                name="state"
                            >
                                <CustomTypeCombo
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    placeHolder="استان تولد"
                                    parentId={stateListId}
                                    onChange={(value) => { setStateId(value); form.setFieldsValue({ city: undefined }); setCityId(-1); }}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={12} sm={12} md={8} lg={3} xl={5}>
                            <div className='add-others-title'>شهر تولد:</div>
                            <Form.Item
                                name="city"
                            >
                                <CustomTypeCombo
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    placeHolder="شهر تولد"
                                    parentId={stateId} // شهرها زیرمجموعه استان هستند
                                    onChange={(value) => { setCityId(value) }}
                                    disabled={!stateId}
                                />
                            </Form.Item>
                        </Col>
                        
                        {period?.getOthersPhoto ?
                            <Col xs={12} sm={12} md={8} lg={2} xl={5} >
                                <div className='add-others-title'>چهره:</div>
                                <Upload
                                    beforeUpload={() => false} // جلوگیری از آپلود خودکار
                                    onChange={handleFileChange}
                                    accept="image/*"
                                    maxCount={1}
                                    fileList={file ? [{ uid: '1', name: file.name, status: 'done', size: file.size }] : []}
                                >
                                    <Button style={{ width: '100%' }} icon={<UploadOutlined />}>انتخاب</Button>
                                </Upload>
                            </Col> : <></>}

                    </Row>
                </Form>
            </div>
            <Row className='sectionFooter'>
                <Col xs={0} sm={0} md={8} lg={16} xl={16} />
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        style={{ width: '98%' }}
                        className='btn-success'
                        htmlType="submit"
                        onClick={() => form.submit()}>
                        <CheckOutlined />
                        ذخیره
                    </Button>
                </Col>
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        className='btn-secondary'
                        style={{ width: '100%' }}
                        onClick={() => cancelInsert()}>
                        <CloseOutlined />
                        لغو </Button>
                </Col>
            </Row>
        </>
    )
}